/*eslint-disable */
export default {
  name: 'percentage-loader-f-file',
  components: {},
  props: ['uploadProgressState'],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}


